import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { PDFExportService } from '../pdf-export.service';
import { PdfSummaryService } from './../pdf-summary-export/pdf-summary.service';

declare const google: any;

@Component({
  selector: 'csi-pdf-export-donut-chart',
  templateUrl: './pdf-export-donut-chart.component.html',
  styleUrls: ['./pdf-export-donut-chart.component.css']
})
export class PdfExportDonutChartComponent implements OnInit {
  private translateObject: any = {};
  public severityClassification = this.pdfSummaryService.severityClassification;

  private severityKeys = Object.keys(this.severityClassification);
  private eyeConfig = {
    rightEye: { cssName: 'right-eye', titleName: 'Right Eye' },
    leftEye: { cssName: 'left-eye', titleName: 'Left Eye' }
  };
  private severityDistribution = {};
  private colorMap = {};
  private titleTextStyle = {
    fontName: 'Times New Roman',
    fontSize: 20
  };

  constructor(
    private pdfExportService: PDFExportService,
    private pdfSummaryService: PdfSummaryService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit() {
    this.translateObject = this.translocoService.getTranslation(
      this.translocoService.getActiveLang()
    );
    Object.entries(this.severityClassification).map(([side, eyeInfo]) => {
      const severityDistribution = {};
      const severityColor = {};
      Object.values(eyeInfo).forEach((eyeInformation: any) => {
        if (!eyeInformation.severity) {
          return;
        }

        severityColor[eyeInformation.severity] = eyeInformation.color;
        severityDistribution[eyeInformation.severity] =
          (severityDistribution[eyeInformation.severity] || 0) + eyeInformation.frequency;
      });

      this.colorMap[side] = { ...severityColor };
      this.severityDistribution[side] = { ...severityDistribution };
    });
    google.charts.load('current', { packages: ['corechart'] });

    google.charts.setOnLoadCallback(() => {
      this.drawChart();
    });
  }

  drawChart(): void {
    for (const severityKey of this.severityKeys) {
      let sortedSeverityDistribution = this.pdfSummaryService.sortOrder(
        this.severityDistribution[severityKey]
      );
      const data = google.visualization.arrayToDataTable([
        ['Severity', 'Count'],
        ...Object.entries(sortedSeverityDistribution)
      ]);
      const eyeConfig = this.eyeConfig[severityKey];
      const cssName = eyeConfig.cssName;
      const colors = this.pdfSummaryService.sortOrder(this.colorMap[severityKey]);
      const titleName = this.translateObject['pdf.' + eyeConfig.titleName];

      const options = {
        title: titleName,
        width: '200',
        height: '200',
        pieHole: 0.3,
        colors: Object.values(colors),
        titleTextStyle: this.titleTextStyle,
        legend: 'none',

        pieSliceText: 'none'
      };

      const chart = new google.visualization.PieChart(
        document.getElementById('donutchart-' + cssName)
      );

      chart.draw(data, options);
      this.createCustomLegend(data, options, cssName);
    }

    this.pdfExportService.chartReady$.next(true);
  }

  createCustomLegend(data, options, cssName) {
    const legendContainer = document.getElementById('custom-legend-' + cssName);
    legendContainer.innerHTML = '';
    const totalNumberOfSigns = this.getTotalNumberOfSigns(data);

    for (let i = 0; i < data.getNumberOfRows(); i++) {
      const label = this.translateObject['pdf.' + data.getValue(i, 0)];
      const value = data.getValue(i, 1);
      const percentage = ((value / totalNumberOfSigns) * 100).toFixed(1);

      const item = document.createElement('div');
      item.style.display = 'flex';
      item.style.alignItems = 'left';
      item.style.gap = '5px';
      item.style.marginRight = '10px';

      const colorBlock = document.createElement('span');
      colorBlock.style.display = 'inline-block';
      colorBlock.style.minWidth = '8px';
      colorBlock.style.maxWidth = '10px';
      colorBlock.style.minHeight = '5px';
      colorBlock.style.maxHeight = '10px';
      colorBlock.style.transform = 'translateY(3.5px)';
      colorBlock.style.backgroundColor = options.colors[i % options.colors.length];

      const text = document.createElement('span');
      text.innerHTML = `<strong>${label}</strong> (${percentage}%)`;

      item.appendChild(colorBlock);
      item.appendChild(text);
      legendContainer.appendChild(item);
    }
  }
  getTotalNumberOfSigns(data): number {
    let totalNumberOfSigns: number = 0;
    for (let i = 0; i < data.getNumberOfRows(); i++) {
      totalNumberOfSigns += data.getValue(i, 1);
    }
    return totalNumberOfSigns;
  }
}
